(() => {
  class GhanaCarousel extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('[data-carousel-track]');
      this.toggle = this.querySelector('[data-carousel-toggle]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.visible = false;
      this.querySelector('[data-carousel-prev]').addEventListener('click', () => this.move(-1));
      this.querySelector('[data-carousel-next]').addEventListener('click', () => this.move(1));
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateToggle();
      });
      this.addEventListener('mouseenter', () => { this.hovered = true; });
      this.addEventListener('mouseleave', () => { this.hovered = false; });
      this.track.addEventListener('pointerdown', () => {
        this.paused = true;
        this.updateToggle();
      });
      this.motion.addEventListener('change', () => {
        this.paused = this.motion.matches;
        this.updateToggle();
      });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
      }, {threshold: 0.15});
      this.observer.observe(this);
      this.timer = setInterval(() => {
        if (this.visible && !this.paused && !this.hovered && !document.hidden && !this.contains(document.activeElement)) this.move(1);
      }, 3800);
      this.updateToggle();
    }
    updateToggle() {
      this.toggle.textContent = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
    }
    move(direction) {
      const first = this.track.firstElementChild;
      if (!first) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = first.getBoundingClientRect().width + gap;
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      if (maximum <= 1) return;
      let next = this.track.scrollLeft + direction * step;
      const wrap = direction > 0 ? this.track.scrollLeft >= maximum - 2 : this.track.scrollLeft <= 2;
      if (wrap) next = direction > 0 ? 0 : maximum;
      this.track.scrollTo({left: Math.max(0, Math.min(maximum, next)), behavior: this.motion.matches || wrap ? 'instant' : 'smooth'});
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.ready = false;
    }
  }
  if (!customElements.get('ghana-carousel')) customElements.define('ghana-carousel', GhanaCarousel);
})();
